// extracted by mini-css-extract-plugin
export default {"button":"AuthFormBtn_button__L03aM"};